<template>
<div class="list">
  <div class="breadcrumb">
    <Breadcrumb>
      <Breadcrumb-item href="#">官网活动</Breadcrumb-item>
      <Breadcrumb-item>学生作品管理</Breadcrumb-item>
    </Breadcrumb>
  </div>
  <div class="search" @keyup.enter="search">
    <Form :label-width="100" :show-message="false" label-postion="right">
      <Row :gutter="32">
        <Col :span="6">
          <Form-item label="学生ID">
            <Input name="uid" v-model="queryParam.uid"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="手机号">
            <Input name="mobile" v-model="queryParam.mobile"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="学生姓名">
            <Input name="userName" v-model="queryParam.userName"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="所属学导">
            <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyAdviserId"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="作品名称">
            <Input name="title" v-model="queryParam.title"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="分组">
            <Select v-model.number="queryParam.ageGroup" placeholder="请选择" clearable>
              <Option v-for="item in $constant.userVideoType" :key="item.code" :value="item.code">{{item.text}}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="期数">
            <Select v-model.number="queryParam.period" placeholder="请选择" clearable>
              <Option v-for="item in $constant.userVideoPeriod" :key="item.code" :value="item.code">{{item.text}}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="是否已上传作品" prop="isUploadVideo">
            <Select v-model.number="queryParam.isUploadVideo" placeholder="请选择" clearable>
              <Option :value="0">否</Option>
              <Option :value="1">是</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="审核状态">
            <Select v-model.number="queryParam.auditStatus" placeholder="请选择" clearable>
              <Option v-for="item in $constant.auditStatus" :key="item.code" :value="item.code">{{item.text}}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="大众口碑分" prop="hasPublicScore">
            <Select v-model.number="queryParam.hasPublicScore" placeholder="请选择" clearable>
              <Option :value="0">否</Option>
              <Option :value="1">是</Option>
            </Select>
          </Form-item>
        </Col>
<!--        <Col :span="6">-->
<!--          <Form-item label="阶段">-->
<!--            <Select v-model.number="queryParam.phase" placeholder="请选择" clearable>-->
<!--              <Option v-for="item in $constant.userVideoPhase" :key="item.code" :value="item.code">{{item.text}}</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </Col>-->
        <Col :span="2">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
        </Col>
      </Row>
    </Form>
  </div>
  <div class="btn-wrap">
    <Row>
        <Col>
          <Button type="primary" @click="onAdd">上传作品</Button>
          <Button type="primary" @click="batchToNextRound">进入下一轮</Button>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search" @click="exportData" >导出</Button>
        </Col>
      </Row>
  </div>
  <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/userVideo/pageList"
        :params="queryParam" :onLoading="onLoading" operator="" @on-selection-change="selectedChange"></List>
  <AddUserVideoModal :value="showAddUserVideoModal" @on-close="showAddUserVideoModal=false" :successCallback="search"></AddUserVideoModal>
  <EditUserVideoModal :value="showEditUserVideoModal" :itemId="itemId" @on-close="showEditUserVideoModal = false"
                      @on-edit-clearid="clearid" :successCallback="search"></EditUserVideoModal>
</div>
</template>

<script>
  import AddUserVideoModal from './modal/AddUserVideoModal'
  import EditUserVideoModal from './modal/EditUserVideoModal'
  export default {
    name: 'UserVideoList',
    components: {EditUserVideoModal, AddUserVideoModal},
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        reload: 0,
        selectionOpenedIds: [],
        queryParam: {
          uid: null,
          title: '',
          userName: '',
          mobile: '',
          studyAdviserId: null,
          ageGroup: null,
          isUploadVideo: null,
          phase: null,
          period: null,
          auditStatus: null,
          hasPublicScore: null
        },
        itemId: null,
        showAddUserVideoModal: false,
        showEditUserVideoModal: false,
        title: [
          {
            type: 'selection',
            width: 40,
            align: 'center'
          },
          {
            title: '排名',
            width: 70,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row._index + 1)
            }
          },
          {
            title: '作品ID',
            width: 80,
            align: 'center',
            key: 'id'
          },
          {
            title: '学生id/姓名',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + '-' + row.nickname)
            }
          },
          {
            title: '手机号',
            width: 125,
            align: 'center',
            key: 'mobile',
            render: (h, params) => {
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                  '****' + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '作品名称',
            width: 230,
            align: 'center',
            key: 'title'
          },
          {
            title: '作品封面',
            width: 100,
            align: 'center',
            key: 'videoPicUrl',
            render: (h, params) => {
              let row = params.row
              if (!row.videoPicUrl) {
                return h('span', '-')
              }
              return h('viewer', {
                style: { display: 'inline-block', verticalAlign: 'middle', height: '40px' }
              }, [
                h('img', {
                  style: { width: '40px', height: '40px', objectFit: 'cover', cursor: 'pointer', verticalAlign: 'middle' },
                  attrs: { src: this.mediaUrl(row.videoPicUrl), alt: '作品封面', title: row.videoPicUrl }
                })
              ])
            }
          },
          {
            title: '作品',
            width: 200,
            align: 'center',
            key: 'videoUrl',
            render: (h, params) => {
              let row = params.row
              if (row.videoUrl) {
                return h('a', {domProps: {title: '点击预览'}, on: {click: () => this.showVideo(row)}}, row.videoUrl)
              } else {
                return h('span')
              }
            }
          },
          {
            title: '分组',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let ageGroup = row.ageGroup
              let typeEnum = $constant.getEnum($constant.userVideoType, ageGroup)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '周期',
            width: 90,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let period = row.period
              let periodEnum = $constant.getEnum($constant.userVideoPeriod, period)
              return h('span', periodEnum && periodEnum.text)
            }
          },
          {
            title: '外教1打分',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('Input', {
                props: {
                  value: row.scoreTch != null ? row.scoreTch : '',
                  placeholder: '-'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== (row.scoreTch != null ? String(row.scoreTch) : '')) {
                      row.scoreTch = newValue ? Number(newValue) : null
                      this.updateUserVideo(row.id, 'scoreTch', newValue ? Number(newValue) : null)
                      this.updateAvgScoreTch(row)
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== (row.scoreTch != null ? String(row.scoreTch) : '')) {
                      row.scoreTch = value ? Number(value) : null
                      this.updateUserVideo(row.id, 'scoreTch', value ? Number(value) : null)
                      this.updateAvgScoreTch(row)
                    }
                  }
                }
              })
            }
          },
          {
            title: '外教2打分',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('Input', {
                props: {
                  value: row.scoreTch2 != null ? row.scoreTch2 : '',
                  placeholder: '-'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== (row.scoreTch2 != null ? String(row.scoreTch2) : '')) {
                      row.scoreTch2 = newValue ? Number(newValue) : null
                      this.updateUserVideo(row.id, 'scoreTch2', newValue ? Number(newValue) : null)
                      this.updateAvgScoreTch(row)
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== (row.scoreTch2 != null ? String(row.scoreTch2) : '')) {
                      row.scoreTch2 = value ? Number(value) : null
                      this.updateUserVideo(row.id, 'scoreTch2', value ? Number(value) : null)
                      this.updateAvgScoreTch(row)
                    }
                  }
                }
              })
            }
          },
          {
            title: '外教平均分',
            width: 120,
            align: 'center',
            key: 'avgScoreTch',
          },
          {
            title: '热度数据分',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('Input', {
                props: {
                  value: row.scoreHot != null ? row.scoreHot : '',
                  placeholder: '-'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== (row.scoreHot != null ? String(row.scoreHot) : '')) {
                      row.scoreHot = newValue ? Number(newValue) : null
                      this.updateUserVideo(row.id, 'scoreHot', newValue ? Number(newValue) : null)
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== (row.scoreHot != null ? String(row.scoreHot) : '')) {
                      row.scoreHot = value ? Number(value) : null
                      this.updateUserVideo(row.id, 'scoreHot', value ? Number(value) : null)
                    }
                  }
                }
              })
            }
          },
          {
            title: '共鸣收藏分',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('Input', {
                props: {
                  value: row.scoreCollect != null ? row.scoreCollect : '',
                  placeholder: '-'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== (row.scoreCollect != null ? String(row.scoreCollect) : '')) {
                      row.scoreCollect = newValue ? Number(newValue) : null
                      this.updateUserVideo(row.id, 'scoreCollect', newValue ? Number(newValue) : null)
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== (row.scoreCollect != null ? String(row.scoreCollect) : '')) {
                      row.scoreCollect = value ? Number(value) : null
                      this.updateUserVideo(row.id, 'scoreCollect', value ? Number(value) : null)
                    }
                  }
                }
              })
            }
          },
          {
            title: '优质评论分',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('Input', {
                props: {
                  value: row.scoreComment != null ? row.scoreComment : '',
                  placeholder: '-'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== (row.scoreComment != null ? String(row.scoreComment) : '')) {
                      row.scoreComment = newValue ? Number(newValue) : null
                      this.updateUserVideo(row.id, 'scoreComment', newValue ? Number(newValue) : null)
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== (row.scoreComment != null ? String(row.scoreComment) : '')) {
                      row.scoreComment = value ? Number(value) : null
                      this.updateUserVideo(row.id, 'scoreComment', value ? Number(value) : null)
                    }
                  }
                }
              })
            }
          },
          {
            title: '大众口碑分',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('Input', {
                props: {
                  value: row.scorePublic != null ? row.scorePublic : '',
                  placeholder: '-'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== (row.scorePublic != null ? String(row.scorePublic) : '')) {
                      row.scorePublic = newValue ? Number(newValue) : null
                      this.updateUserVideo(row.id, 'scorePublic', newValue ? Number(newValue) : null)
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== (row.scorePublic != null ? String(row.scorePublic) : '')) {
                      row.scorePublic = value ? Number(value) : null
                      this.updateUserVideo(row.id, 'scorePublic', value ? Number(value) : null)
                    }
                  }
                }
              })
            }
          },
          {
            title: '综合得分',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('Input', {
                props: {
                  value: row.scoreAll != null ? row.scoreAll : '',
                  placeholder: '-'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== (row.scoreAll != null ? String(row.scoreAll) : '')) {
                      row.scoreAll = newValue ? Number(newValue) : null
                      this.updateUserVideo(row.id, 'scoreAll', newValue ? Number(newValue) : null)
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== (row.scoreAll != null ? String(row.scoreAll) : '')) {
                      row.scoreAll = value ? Number(value) : null
                      this.updateUserVideo(row.id, 'scoreAll', value ? Number(value) : null)
                    }
                  }
                }
              })
            }
          },
          // {
          //   title: '阶段',
          //   width: 70,
          //   align: 'center',
          //   render: (h, params) => {
          //     let row = params.row
          //     let phase = row.phase
          //     let phaseEnum = $constant.getEnum($constant.userVideoPhase, phase)
          //     return h('span', phaseEnum && phaseEnum.text)
          //   }
          // },
          // {
          //   title: '票数',
          //   width: 80,
          //   align: 'center',
          //   key: 'voteCount'
          // },
          {
            title: '学导id/姓名',
            width: 160,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.studyAdviserId === 0 ? '未分配' : row.studyAdviserId + '-' + row.studyAdviserName)
            }
          },
          {
            title: '短视频链接',
            className: 'sv-plat-column',
            width: 160,
            align: 'center',
            render: (h, params) => {
              let lines = this.platformRows(params.row)
              if (!lines.length) return h('span', '-')
              return h('div', lines.map(item => this.svLine(h, [
                h('Poptip', {
                  props: {
                    trigger: 'hover',
                    transfer: true,
                    placement: 'top',
                    width: 360
                  }
                }, [
                  h('span', {
                    style: { display: 'inline-block', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'top' }
                  }, item.label + '：' + item.url),
                  h('div', {
                    slot: 'content',
                    style: { maxWidth: '360px', whiteSpace: 'normal', wordBreak: 'break-all', textAlign: 'left' }
                  }, item.label + '：' + item.url)
                ])
              ])))
            }
          },
          {
            title: '原视频',
            className: 'sv-plat-column',
            width: 200,
            align: 'center',
            render: (h, params) => {
              let lines = this.platformRows(params.row)
              if (!lines.length) return h('span', '-')
              return h('div', lines.map(item => {
                let url = item.task && item.task.videoFileUrl
                if (!url) return this.svLine(h, item.label + '：-')
                return this.svLine(h, [
                  h('span', item.label + '：'),
                  h('a', {
                    attrs: { title: url },
                    style: { display: 'inline-block', maxWidth: '130px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'top' },
                    on: { click: () => this.showSvFile(url) }
                  }, url)
                ])
              }))
            }
          },
          {
            title: '短视频封面',
            className: 'sv-plat-column',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let lines = this.platformRows(params.row)
              if (!lines.length) return h('span', '-')
              return h('div', lines.map(item => {
                let url = item.task && item.task.coverUrl
                if (!url) return this.svLine(h, item.label + '：-')
                return this.svLine(h, [
                  h('span', { style: { verticalAlign: 'top' } }, item.label + '：'),
                  h('viewer', { style: { display: 'inline-block', verticalAlign: 'top', height: '32px' } }, [
                    h('img', {
                      style: { width: '28px', height: '28px', marginTop: '2px', objectFit: 'cover', cursor: 'pointer', verticalAlign: 'top' },
                      attrs: { src: this.mediaUrl(url), alt: '封面' }
                    })
                  ])
                ])
              }))
            }
          },
          {
            title: '短视频同步',
            className: 'sv-plat-column',
            width: 130,
            align: 'center',
            render: (h, params) => {
              let lines = this.platformRows(params.row)
              if (!lines.length) return h('span', '-')
              let map = { pending: '待抓取', running: '抓取中', success: '成功', fail: '失败' }
              return h('div', lines.map(item => {
                if (!item.task) return this.svLine(h, item.label + '：未抓取')
                let text = item.label + '：' + (map[item.task.status] || '-')
                if (item.task.status !== 'fail') return this.svLine(h, text)
                return this.svLine(h, [
                  h('Tooltip', {
                    props: {
                      content: item.task.errorMsg || '',
                      placement: 'top',
                      transfer: true,
                      maxWidth: 300,
                      disabled: !item.task.errorMsg
                    }
                  }, [
                    h('span', { style: { color: '#ed4014', cursor: item.task.errorMsg ? 'help' : 'default' } }, text)
                  ])
                ])
              }))
            }
          },
          {
            title: '短视频作者',
            className: 'sv-plat-column',
            width: 160,
            align: 'center',
            render: (h, params) => {
              let lines = this.platformRows(params.row)
              if (!lines.length) return h('span', '-')
              return h('div', lines.map(item => {
                let text = item.label + '：' + ((item.task && item.task.author) || '-')
                return this.svLine(h, [
                  h('span', {
                    attrs: { title: text },
                    style: { display: 'inline-block', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'top' }
                  }, text)
                ])
              }))
            }
          },
          {
            title: '赞/藏/评',
            className: 'sv-plat-column',
            width: 160,
            align: 'center',
            render: (h, params) => {
              let r = params.row
              let lines = this.platformRows(r)
              if (!lines.length) return h('span', '-')
              let rows = lines.map(item => {
                let t = item.task
                if (!t) return this.svLine(h, item.label + '：-')
                return this.svLine(h, item.label + '：' + (t.likeCount || 0) + '/' + (t.collectCount || 0) + '/' + (t.commentCount || 0))
              })
              rows.push(this.svLine(h, '合计：' + (r.svLikeCount || 0) + '/' + (r.svCollectCount || 0) + '/' + (r.svCommentCount || 0)))
              return h('div', rows)
            }
          },
          {
            title: '修复标记',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              if (row.repairStatus === 1) {
                return h('Tag', {props: {color: 'green'}}, '已修复')
              }
              return h('span', '-')
            }
          },
          {
            title: '审核状态',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let row = params.row
              let auditStatus = row.auditStatus
              let auditStatusEnum = $constant.getEnum($constant.auditStatus, auditStatus)
              return h('span', auditStatusEnum && auditStatusEnum.text)
            }
          },
          {
            title: '操作',
            width: 220,
            align: 'center',
            render: (h, params) => {
              let self = this
              let row = params.row
              let links = []
              links.push(h('a', {on: {click: () => self.onEdit(row)}}, '编辑'))
              if (self.hasShortVideoUrl(row)) {
                links.push(h('span', ' | '))
                links.push(h('a', {on: {click: () => self.fetchShortVideo(row)}}, '抓取'))
              }
              if (row.auditStatus === 1) {
                links.push(h('span', ' | '))
                links.push(h('a', {on: {click: () => self.auditVideo(row.id, 2)}}, '不通过'))
              } else if (row.auditStatus === 2) {
                links.push(h('span', ' | '))
                links.push(h('a', {on: {click: () => self.auditVideo(row.id, 1)}}, '通过'))
              } else {
                links.push(h('span', ' | '))
                links.push(h('a', {on: {click: () => self.auditVideo(row.id, 1)}}, '通过'))
                links.push(h('span', ' | '))
                links.push(h('a', {on: {click: () => self.auditVideo(row.id, 2)}}, '不通过'))
              }
              return h('span', links)
            }
          }
        ]
      }
    },
    methods: {
      showIndex (videoPicUrl) {
        if (videoPicUrl) {
          window.open('http://medias.kouyujie.cn/' + videoPicUrl + '?' + Date.parse(new Date()))
        }
      },
      search () {
        this.selectionOpenedIds = []
        this.reload = new Date().getTime()
      },
      onAdd () {
        this.showAddUserVideoModal = true
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      clearid () {
        this.itemId = null
      },
      onEdit (row) {
        this.showEditUserVideoModal = true
        this.itemId = row.id
      },
      hasShortVideoUrl (row) {
        return !!(row && (row.douyinUrl || row.xhsUrl || row.channelsUrl))
      },
      fetchShortVideo (row) {
        if (!row || !row.id) {
          this.$Message.warning('作品ID无效')
          return
        }
        if (!this.hasShortVideoUrl(row)) {
          this.$Message.warning('请先编辑填写短视频链接')
          return
        }
        let self = this
        self.$http.post('/userVideo/shortVideo/fetch', { id: row.id }).then(function (res) {
          self.$Message.success((res.data && res.data.message) ? res.data.message : '已提交')
          self.search()
        })
      },
      selectedChange (selection) {
        this.selectionOpenedIds = selection
      },
      showVideo (row) {
        let videoUrl = row.videoUrl
        if (videoUrl) {
          window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()))
        }
      },
      showSvFile (url) {
        if (!url) {
          return
        }
        let playUrl = this.mediaUrl(url)
        let joiner = playUrl.indexOf('?') >= 0 ? '&' : '?'
        window.open(playUrl + joiner + Date.parse(new Date()))
      },
      platformRows (row) {
        let tasks = Array.isArray(row.svTasks) ? row.svTasks : []
        return [
          { platform: 'douyin', label: '抖音', url: row.douyinUrl },
          { platform: 'xhs', label: '小红书', url: row.xhsUrl },
          { platform: 'channels', label: '视频号', url: row.channelsUrl }
        ].filter(item => item.url).map(item => {
          item.task = tasks.find(t => t.platform === item.platform) || null
          return item
        })
      },
      svLine (h, children) {
        return h('div', {
          style: { height: '32px', lineHeight: '32px', overflow: 'hidden', whiteSpace: 'nowrap' }
        }, children)
      },
      mediaUrl (url) {
        if (!url) {
          return ''
        }
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
          return url
        }
        return 'http://medias.kouyujie.cn/' + url
      },
      auditVideo (id, auditStatus) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: auditStatus === 1 ? '是否 <b>通过</b> 此作品？' : '是否 <b>不通过</b> 此作品？',
          width: 300,
          okText: auditStatus === 1 ? '确定通过' : '确定不通过',
          loading: true,
          onOk: () => {
            self.$http.post('/userVideo/check', {id: id, auditStatus: auditStatus}).then(function (resp) {
              self.search()
              self.$Message.success('操作成功!')
              self.$Modal.remove()
            })
          }
        })
      },
      batchToNextRound () {
        if (this.selectionOpenedIds.length <= 0) {
          this.$Message.warning('请选择需要取消的课程！')
          return
        }
        let self = this
        let ids = []
        if (this.selectionOpenedIds && this.selectionOpenedIds.length > 0) {
          for (let i in this.selectionOpenedIds) {
            let dto = this.selectionOpenedIds[i]
            ids[i] = dto.id
          }
        }
        self.$Modal.confirm({
          title: '提示',
          content: '是否确认进入下一轮？',
          width: 300,
          loading: true,
          onOk: () => {
            self.$http.post('/userVideo/batchToNextRound', {videoIds: ids.join(',')}).then(function (res) {
              self.search()
              self.$Message.success('操作成功!')
              self.$Modal.remove()
            })
          }
        })
      },
      updateUserVideo (id, field, value) {
        this.$http.post('/userVideo/update', {id: id, [field]: value}).then(function (res) {
          if (res && res.data > 0) {
            this.$Message.success('更新成功')
          } else {
            this.$Message.error(res.msg)
          }
        }.bind(this))
      },
      updateAvgScoreTch (row) {
        const s1 = row.scoreTch
        const s2 = row.scoreTch2
        let avg = null
        if (s1 != null && s2 != null) {
          avg = (Number(s1) + Number(s2)) / 2
        } else if (s1 != null) {
          avg = Number(s1)
        } else if (s2 != null) {
          avg = Number(s2)
        }
        row.avgScoreTch = avg
      },
      exportData () {
        this.exportLoading = true
        this.$http.get('/userVideo/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'text/csv'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '学生作品列表.csv'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg)
          }
        }).catch((e) => {
          this.exportLoading = false
        })
      }
    }
  }
</script>


<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-bottom: 12px;
  }
  .list /deep/ td.sv-plat-column {
    vertical-align: top;
    padding-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// UserVideoList.vue?506221bc